import api from './axios';

export const listCustomers = () => api.get('/customers').then((r) => r.data);

// Server-side search + pagination: the master register can exceed the 500-row
// per-request cap, so search/filter must run in the database, not on a client-side
// slice of it. Returns the current page plus the total match count from the header.
export const listCustomersPage = ({ page = 1, limit = 50, search = '' } = {}) =>
  api.get('/customers', { params: { page, limit, search } }).then((r) => ({
    items: r.data,
    total: Number(r.headers['x-total-count'] ?? r.data.length),
  }));
export const createCustomer = (data) => api.post('/customers', data).then((r) => r.data);
export const updateCustomer = (id, data) => api.put(`/customers/${id}`, data).then((r) => r.data);
export const deleteCustomer = (id) => api.delete(`/customers/${id}`).then((r) => r.data);
export const bulkUploadCustomers = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/customers/bulk-upload', formData).then((r) => r.data);
};
